import { baseQuerySetup,getResponsedata,getResponseResult,onQueryStarted, onCacheEntryAdded , transformResponse } from 'config/index';
import { successToast } from 'constants/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { setNavLoader } from './App.service';
let dashboardReducer = 'DashboardReducer';
let dashboardTag = 'DashboardTag';
let newUsersTag = 'NewUsersTag';
let INVITATION_TAG = 'INVITATION_TAG';
export const dashboardApi = createApi({
    reducerPath: dashboardReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [dashboardTag, INVITATION_TAG],
    endpoints: (builder) => ({
        getListOfInvitations: builder.query({
            query: (USERTYPE)=>{
                if (USERTYPE) {
                    return { url: '/invitation?role=' + USERTYPE, method: 'GET' };
                }
                return { url: '/invitation', method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: (response)=>{
                return response.result.data;
            },
            providesTags: [INVITATION_TAG]
        }),
        InviteUsers: builder.mutation({
            query: (body) => {
                return { url: '/invitation/send-multiple', method: 'POST', body };
            },
            async onQueryStarted({ invitedToRole }, { dispatch , queryFulfilled }) {
                try {
                    dispatch(setNavLoader(true));
                    const { data } = await queryFulfilled;
                    if (data && data.length > 0) {
                        dispatch(dashboardApi.util.updateQueryData('getListOfInvitations','' ,(draftPost) => {
                            return [...data , ...draftPost];
                        }));
                        dispatch(dashboardApi.util.updateQueryData('getListOfInvitations',
                            invitedToRole ,
                            (draftPost) => {
                                return [...data , ...draftPost];
                            }));
                        dispatch(setNavLoader(false));
                    }
                } catch (error) {
                    dispatch(setNavLoader(false));
                }
            },
            onCacheEntryAdded,
            transformResponse: (response)=>{
                // invite user
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    if (response.result?.message) {
                        successToast(response.result?.message);
                    }
                }
                return response.result.data.filter((row)=> !!row);
            }

        }),
        ResentInvite: builder.mutation({
            query: (invitation) => {
                return { url: '/invitation/' + invitation._id + '/resend', method: 'POST' };
            },
            async onQueryStarted({ _id , invitedToRole }, { dispatch , queryFulfilled }) {
                try {
                    dispatch(setNavLoader(true));
                    const data = await queryFulfilled;
                    dispatch(dashboardApi.util.updateQueryData('getListOfInvitations',
                        '' ,
                        (draftPost) => {
                            let record = draftPost.find((row)=> row._id === _id);
                            record.updatedAt = new Date();
                        }));
                    dispatch(dashboardApi.util.updateQueryData('getListOfInvitations',
                        invitedToRole ,
                        (draftPost) => {
                            let record = draftPost.find((row)=> row._id === _id);
                            record.updatedAt = new Date();
                        }));

                    if (data) {
                        dispatch(setNavLoader(false));
                    }
                } catch (error) {
                    dispatch(setNavLoader(false));
                }
            },
            onCacheEntryAdded,
            transformResponse
        }),
        getDashboardstats: builder.query({
            query: () => {
                return { url: '/dashboard/stats' , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata,
            providesTags: [dashboardTag]
        }),
        getWalletBalance: builder.query({
            query: () => {
                return { url: '/blockchain/wallet-balance' , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata,
            providesTags: [dashboardTag]
        }),

        getNewUsers: builder.query({
            query: () => {
                return { url: '/dashboard/new-users' , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponseResult,
            providesTags: [newUsersTag]
        })
    })
});
export const { useGetWalletBalanceQuery , useGetDashboardstatsQuery,useGetNewUsersQuery, useGetListOfInvitationsQuery , useResentInviteMutation , useInviteUsersMutation } = dashboardApi;
